import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { Routes } from 'src/routes';
import { FormattedMessage, defineMessages } from 'react-intl';
import { useLocation } from 'react-router-dom';

const messages = defineMessages({
    callToAction: {
        id: 'callToAction',
        defaultMessage: 'Időpont foglalása'
    }
})

const CallToAction = () => {
    const location = useLocation();

    return (
        <Link
            to={{
                pathname: Routes.Book,
                hash: 'booking-flow',
                search: location.search
            }}
            className="App__call-to-action button button--primary">
            <FormattedMessage {...messages.callToAction} />
        </Link>
    );
}

export default CallToAction;